var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.5 15.5",
    style: {
      enableBackground: "new 0 0 15.5 15.5"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.statistics-svg{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "statistics-svg",
    d: "M1.7,14.8h0.5c0.5,0,0.9-0.4,0.9-1v-2.4c0-0.5-0.4-1-0.9-1H1.7c-0.5,0-0.9,0.4-0.9,1v2.4 C0.8,14.3,1.2,14.8,1.7,14.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "statistics-svg",
    d: "M13.3,14.8h0.5c0.5,0,0.9-0.4,0.9-1V8.5c0-0.5-0.4-1-0.9-1h-0.5c-0.5,0-0.9,0.4-0.9,1v5.3 C12.4,14.3,12.8,14.8,13.3,14.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "statistics-svg",
    d: "M7.5,14.8H8c0.5,0,0.9-0.4,0.9-1V1.7c0-0.5-0.4-1-0.9-1H7.5c-0.5,0-0.9,0.4-0.9,1v12.1 C6.6,14.3,7,14.8,7.5,14.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.e7a69d9660085becb7d3ed47039a654c.svg";
export { ForwardRef as ReactComponent };